module.exports = __webpack_public_path__ + "static/journey-78a7daccda590bcb09b8cbe12b4a9b29.svg";